import { css } from "styled-components";

export const hideSidebarStyles = css<{ showSidebar: boolean }>`
  width: 100%;
  transition: width 0.3s ease-out;
  transition: left 0.3s ease-out;
`;
